import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "./Modal";
import Button from "./Button";
import InputRowRaw from "./InputRow";
import { ShowNotice } from "Store";

export default class ModalWithField extends Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.any,
      isRequired: PropTypes.bool
    })),
    title: PropTypes.string,
    isLoading: PropTypes.bool,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
  };
  static defaultProps = {
    fields: [],
    cancelText: "Cancel",
    confirmText: "OK"
  };

  componentWillMount() {
    const fields = {};
    for (const { name, displayName, type, value } of this.props.fields) {
      fields[name] = {
        name,
        displayName,
        value,
        type: type || 'text'
      };
    }
    this.setState(fields);
  }

  componentWillReceiveProps() {
    const fields = {};
    const state = this.state
    for (const { name, displayName, type, value } of this.props.fields) {
      if(!state[name].value) {
        fields[name] = {
          name,
          displayName,
          value,
          type: type || 'text'
        };
      } else {
        fields[name] = Object.assign({}, state[name])
      }
    }

    this.setState(fields);  
  }

  render() {
    const {
      title,
      isLoading,
      fields,
      cancelText,
      confirmText,
      onCancel
    } = this.props;
    const state = this.state;

    // prepare field rows
    const rows = [];
    for (const { name, displayName, value, type } of fields) {
      let realValue = state[name].value || value
      if(type == 'dropdown') {
        realValue = value
      }
      rows.push(
        <InputRow
          key={name}
          labelWidth={100}
          label={displayName}
          value={realValue}
          type={type}
          zIndex={9999}
          onChange={text => {
            const newFields = Object.assign({}, state);
            if(type == 'dropdown') {
              newFields[name].selected = text
            } else {
              newFields[name].value = text;
            }            

            this.setState(newFields);
          }}
        />
      );
    }

    return (
      <Modal>
        <Wrapper>
          <Text>{title}</Text>
          <form
            onSubmit={event => {
              this.onConfirm();
              event.preventDefault();
            }}
          >
            {rows}
            <SubmitButton type="submit" />
          </form>
          <Buttons>
            <Button
              width={100}
              onClick={onCancel}
              color="gray"
              disabled={isLoading}
            >
              {cancelText}
            </Button>
            <Button
              width={100}
              onClick={this.onConfirm}
              loading={isLoading}
              disabled={isLoading}
            >
              {confirmText}
            </Button>
          </Buttons>
        </Wrapper>
      </Modal>
    );
  }

  onConfirm = () => {
    const { fields, onConfirm } = this.props;
    if (onConfirm) {
      // check if all fields has been filled
      let isFilled = true;
      for (const { name, isRequired } of fields) {
        const data = this.state[name]
        const isDropdownEmpty = data.type === 'dropdown' && !data.selected
        const isTextEmpty = data.type !== 'dropdown' && !data.value
        if (isDropdownEmpty && isRequired || isTextEmpty && isRequired) {
          isFilled = false;
          console.log("Is empty!", name, isRequired, this.state[name])
          break;
        }
      }

      if (isFilled) {
        onConfirm(this.state);
      } else {
        ShowNotice("generic-incomplete-field-error");
      }
    }
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  align-items: center;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;
const SubmitButton = styled.button`
  display: none;
`;
const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-common/ModalWithField.js